import { useQuery } from "@tanstack/react-query";
import { getSourceDefaultStains } from "../services";
import type { SourceDefaultStain } from "../services/sourceDefaultStains.service";

export function useSourceDefaultStainsForPreview(
  sourceId?: string,
  finding?: string,
  subsiteId?: string,
  practiceId?: string,
  billingScenarioId?: string,
  casePrefix?: string,
  isProcessedMaterial?: boolean
) {
  return useQuery<SourceDefaultStain[]>({
    queryKey: [
      "sourceDefaultStainsPreview",
      sourceId,
      finding,
      subsiteId,
      practiceId,
      billingScenarioId,
      casePrefix,
      isProcessedMaterial,
    ],
    queryFn: async () => {
      if (!sourceId) return [];
      return getSourceDefaultStains(
        sourceId,
        finding,
        subsiteId,
        practiceId,
        billingScenarioId,
        casePrefix,
        isProcessedMaterial
      );
    },
    enabled: !!sourceId,
    staleTime: 1000 * 60 * 5,
  });
}
